<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.file-alt-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('Report') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app rounded-md" to="/admin">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="generateReport">
          <div class="px-4 py-5 sm:p-6">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3 md:flex md:space-x-2">
                <div class="w-full">
                  <label class="form-label flex justify-between" for="starting_date">
                    {{ $t('Stating date') }}
                    <small class="text-sm text-gray-400" v-if="report.starting_date"> {{ report.starting_date }} 00:00:00 </small>
                  </label>
                  <div class="pt-1">
                    <input type="date" v-model="report.starting_date" id="starting_date" class="form-input" required />
                  </div>
                </div>
                <div class="w-full">
                  <label class="form-label flex justify-between" for="ending_date">
                    {{ $t('Ending date') }}
                    <small class="text-sm text-gray-400" v-if="report.ending_date"> {{ report.ending_date }} 23:59:59 </small>
                  </label>
                  <div class="pt-1">
                    <input type="date" v-model="report.ending_date" id="ending_date" class="form-input" required />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-green" type="submit">
                {{ $t('Generate') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'report',
  metaInfo() {
    return {
      title: this.$i18n.t('Report'),
    };
  },
  data() {
    return {
      loading: false,
      report: {
        ending_date: null,
        starting_date: null,
      },
    };
  },
  methods: {
    generateReport() {
      this.loading = true;
      this.$router.push({ path: '/print/report', query: this.report });
    },
  },
};
</script>
